export const NAV_HEIGHT_MOBILE = 70;
export const NAV_HEIGHT_DESKTOP = 107;
